// ── Standby (Overtime Policy 2.a.iv) ─────────────────────────────────────────
//
// Standby is paid at a flat £2 an hour "between 4pm and 8am weekdays and all
// weekend". Nobody records clock times for it, and nobody needs to: the policy
// fixes the window, so the date alone says how long a standby slot is.
//
//   weekday          4pm to 8am the next morning     16 hours
//   Saturday, Sunday 8am to 8am the next morning     24 hours
//   bank holiday     treated as a weekend day         24 hours
//
// The Standby Rota derived the same two figures from the day of the week; the
// PLOW's Standby row does the same from the date the cell sits in. The bank
// holiday rule is the one place the PLOW differs from the rota, which counted
// a bank holiday Monday as an ordinary weekday: the policy pays standby for
// "all weekend" and a bank holiday is a non-working day in the same sense.
//
// Pure functions. The caller supplies an isHoliday predicate; the server reads
// bank_holidays, the frontend the bank-holidays feed, and the tests literals.

export const STANDBY_RATE_PER_HOUR = 2;
export const WEEKDAY_EVENING_HOURS = 16;
export const WEEKEND_DAY_HOURS = 24;

export const STANDBY_SLOT_TYPES = {
  weekday_evening: { hours: WEEKDAY_EVENING_HOURS, label: 'Weekday evening', window: '4pm to 8am' },
  weekend_day:     { hours: WEEKEND_DAY_HOURS,     label: 'Weekend day',     window: '8am to 8am' },
};

/** The standby slot a date carries: its type, hours and the window it covers. */
export function standbySlotFor(dateISO, isHoliday = () => false) {
  const d = new Date(`${String(dateISO).slice(0, 10)}T00:00:00Z`);
  if (isNaN(d)) return null;
  const dow = d.getUTCDay();
  const weekend = dow === 0 || dow === 6 || !!isHoliday(dateISO);
  const slot_type = weekend ? 'weekend_day' : 'weekday_evening';
  return { slot_type, ...STANDBY_SLOT_TYPES[slot_type] };
}

/** What a slot pays: the flat rate on its hours, or nothing for somebody who cannot claim standby. */
export function standbyPay(hours, canClaim = true) {
  return canClaim ? Math.round(hours * STANDBY_RATE_PER_HOUR * 100) / 100 : 0;
}
